import { css } from '../style-system';
var content = {
  bottom: css({
    alignItems: 'flex-end',
    display: 'flex',
    justifyContent: 'center'
  }),
  center: css({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  }),
  left: css({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start'
  }),
  right: css({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end'
  }),
  top: css({
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'center'
  })
};
export var alignment = {
  center: css({
    margin: 'auto'
  }),
  content: content,
  left: css({
    marginRight: 'auto'
  }),
  right: css({
    marginLeft: 'auto'
  })
};